import AssignAgentSelector from './container';

export default AssignAgentSelector;
